import React from 'react'

import UA0001 from './templates/UserAgreement/UA0001'

import DEFAULT from './templates/Default/DEFAULT'
import Layout from './components/Layout'
import UAMigrationApp from './tools/UAMigrationTool/UAMigrationTool'

import logger from './utils/contentLogger'

import './styles/app.less'

/**
 *
 * 1. Resolve template (using mapping)
 * 2. import template
 *
 */

const TEMPLATE_PAGE_GROUP_MAP = {
  UA0001: ['ua'],
  DEFAULT: ['pricing'],
  UAMigrationApp: ['uamtool'],
}

const TEMPLATE_COMP_MAP = {
  UA0001,
  DEFAULT,
  UAMigrationApp,
}

function getTemplate(pageGroup) {
  let templateId = ''
  for (
    let i = 0, keys = Object.keys(TEMPLATE_PAGE_GROUP_MAP);
    i < keys.length;
    i++
  ) {
    if (TEMPLATE_PAGE_GROUP_MAP[keys[i]].includes(pageGroup)) {
      templateId = keys[i]
      break
    }
  }
  templateId = templateId || 'DEFAULT'
  return TEMPLATE_COMP_MAP[templateId]
}

export class App extends React.Component {
  componentDidMount() {
    logger.cal.info('APP_DID_MOUNT')
  }

  componentWillUnmount() {
    logger.cal.info('APP_WILL_UNMOUNT')
    logger.flush()
  }
  render() {
    const Template = getTemplate(this.props.pageGroup)
    logger.cal.info('TEMPLATE', Template)
    logger.cal.info('PAGE_NAME', this.props.pageName)
    return (
      <Layout>
        <Template pageContent={this.props.pageContent} />
      </Layout>
    )
  }
}
export default App
